module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/unlock-4e96ea29d526f986f3400be9a8175d41.svg";